export default __webpack_public_path__ + "static/media/view_2.1738dcf4.jpg";